import { render, staticRenderFns } from "./WorkerLogs.vue?vue&type=template&id=e774c35a&"
import script from "./WorkerLogs.vue?vue&type=script&lang=js&"
export * from "./WorkerLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports